<template>
    <div class="add_person_mask"  v-if="addOk">
    <el-card class="add_account">
        <div slot="header" class="clearfix" style="text-align:center;">
            <span style="line-height: 36px;">新建个人号</span>
        </div>
        <div class="resourseContent">
            <p>
                <span class="col-lg-1">个人号名称:</span><el-input class="col-lg-2" v-model="name"></el-input>
            </p>
            <p>
                <span class="col-lg-1">个人号文章链接:</span><el-input class="col-lg-2" v-model="link"></el-input>
            </p>
            <p>
              <span class="col-lg-1">生效日期:</span><el-date-picker
                v-model="startDate"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </p>
            <p>
              <span class="col-lg-1">结束日期:</span><el-date-picker
                v-model="endDate"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </p>
            <p>
                <span class="col-lg-1">推广配额:</span><el-input class="col-lg-2" v-model="extensionQuota" placeholder="不输入则不限制"></el-input>
            </p>
            <p>
                <span class="col-lg-1">机器分配:</span><el-button size="small" type="primary" @click="sltDevice">选择机器</el-button>
            </p>
            <p v-if="sltList.length !== 0">
              <span class="col-lg-1">已选择:</span><span style="display:inline-block;overflow:hidden;text-overflow: ellipsis;white-space: nowrap;line-height: 36px;" class="col-lg-2">
                <span v-for="item in sltList" style="color:#888;font-size:13px;margin-right:10px;">{{item}}</span>
              </span>
            </p>
            <p>
                <span class="col-lg-1" style="float:left;">个人号头像:</span>
                <el-upload
                    ref="upload"
                    class="upload-demo"
                    action="http://upload.qiniu.com/"
                    :data="myForm"
                    method="post"
                    :on-preview="handlePreview"
                    :show-file-list="false"
                    :before-upload="handleBeforeUpload"
                    :on-success="handleSuccess"
                    :multiple="isMultiple"
                    :file-list="fileList1">
                    <el-button size="small" type="primary" @click="ctrlType(0)">选择文件</el-button>
                </el-upload>
                <span v-if="img1==''" :style="green1">{{img1!=''?img1:'(提示:请选择m*m px的Logo)'}}</span>
                <img :src="img1" width="50" height="50" v-else style="margin-left:20px;"/>
            </p>
            <p style="display: inline-block;width: 100%;">
                <span class="col-lg-1" style="float:left;">个人号二维码:</span>
                <el-upload
                    ref="upload"
                    class="upload-demo"
                    action="http://upload.qiniu.com/"
                    :data="myForm"
                    method="post"
                    :on-preview="handlePreview"
                    :show-file-list="false"
                    :before-upload="handleBeforeUpload"
                    :on-success="handleSuccess"
                    :multiple="isMultiple"
                    :file-list="fileList2">
                    <el-button size="small" type="primary" @click="ctrlType(1)">选择文件</el-button>
                </el-upload>
                <span v-if="img2==''" :style="green2">{{img2!=''?img2:'(提示:请选择m*m px的二维码)'}}</span>
                <img :src="img2" width="55" height="55" v-else style="margin-left:20px;"/>
            </p>
            <p style="text-align:center;margin-top:60px;"><el-button type="success" @click="commit" style="width: 240px;">提交</el-button></p>
        </div>
        <span @click="boxColose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
    </el-card>
    <pu-pop-right
      :see-pop-right-ok="popSltDevice" 
      @closeSeeRightPop="closeSeeRightPop">
    </pu-pop-right>
    </div>
</template>
<script>
    import $ajax from '../../https/config'
    import puPopRight from '@/page/adMgr/puPopRight'
    export default {
      props: ['addShow'],
      components: {
        'pu-pop-right': puPopRight
      },
      data () {
        return {
          labelPosition: 'right',
          loading: false,
          fileList1: [],
          fileList2: [],
          form: {},
          name: '',
          link: 'www.laibaozhi.com',
          myType: 0,
          content: '',
          img1: '',
          img2: '',
          isMultiple: true,
          popSltDevice: false,
          extensionQuota: '',
          startDate: new Date(),
          endDate: '',
          sltList: []
        }
      },
      computed: {
        addOk: function () {
          return this.addShow
        },
        green1: function () {
          return this.img1 !== '' ? 'color:green' : ''
        },
        green2: function () {
          return this.img2 !== '' ? 'color:green' : ''
        },
        myForm: {
          set: function (value) {
            this.form = value
          },
          get: function () {
            return this.form
          }
        }
      },
      created: function () {
        this.getUpToken()
      },
      methods: {
        sltDevice () {
          this.popSltDevice = true
        },
        closeSeeRightPop (val) {
          if (val !== '') {
            this.sltList = val.split('|')
          }
          this.popSltDevice = false
        },
        lbzGetDate (lDate) {
          var mdate = lDate.split(/[- : /]/)
          var resultDate = new Date(mdate[0], mdate[1] - 1, mdate[2], mdate[3], mdate[4], mdate[5])
          return resultDate
        },
        boxColose () {
          this.link = ''
          this.img1 = ''
          this.img2 = ''
          this.name = ''
          this.content = ''
          this.$emit('closeAddAccount', false)
        },
        getUpToken () {
          var myUrl = 'http://platform.songzb.com:32000/qiniuToken'
          var _this = this
          $ajax.get(myUrl, '', '', function (res) {
            _this.form.token = res.uptoken
          }, function () {
          })
        },
        handlePreview (file) {
        },
        handleBeforeUpload (file) {
          var last
          last = file.name.split('.').pop()
          if (last !== 'jpg' && last !== 'png' && last !== 'jpeg') {
            this.$message({
              type: 'error',
              message: '图片格式错误'
            })
            return false
          }
          var str = 'zdsimg-' + (new Date().getTime()) + Math.ceil(Math.random() * 10) + '.' + last
          this.form.key = str
        },
        handleSuccess (response, file, fileList) {
          if (this.myType === 0) {
            this.img1 = 'http://res.songzb.com/' + response.key
          } else {
            this.img2 = 'http://res.songzb.com/' + response.key
          }
        },
        ctrlType (type) {
          if (type === 0) {
            this.myType = 0
          } else {
            this.myType = 1
          }
        },
        commit () {
          var that = this
          // var startTime = new Date(that.startDate).getFullYear() + '-' + (new Date(that.startDate).getMonth() + 1) + '-' + new Date(that.startDate).getDate()
          var endTime = new Date(that.endDate).getFullYear() + '-' + (new Date(that.endDate).getMonth() + 1) + '-' + new Date(that.endDate).getDate()
          var params = {
            name: that.name,
            deviceCode: that.sltList.join('|'),
            // startTime: that.lbzGetDate(startTime + ' 00:00:00'),
            endTime: that.lbzGetDate(endTime + ' 23:59:59'),
            startTime: that.startDate,
            // endTime: that.endDate,
            fansCount: that.extensionQuota ? that.extensionQuota : 0,
            wxArticleUrl: that.link ? that.link : 'www.laibaozhi.com',
            wx_logo: that.img1,
            qrcode: that.img2,
            pType: 1
          }
          if (this.name.trim() === '') {
            that.$message({
              type: 'error',
              message: '个人号名字不能为空'
            })
            return
          }
          if (this.startDate === '' || this.endDate === '') {
            that.$message({
              type: 'error',
              message: '请选择时间'
            })
            return
          }
          if (this.img1 === '' || this.img2 === '') {
            that.$message({
              type: 'error',
              message: '请选择要上传的资源！'
            })
            return
          }
          $ajax.post('wxqyv2/sbz/addPersonalWeixin', params, 'headers', function (res) {
            if (res.resultStatus === true) {
              that.$message({
                type: 'success',
                message: '添加个人号成功！'
              })
              that.boxColose()
            }
          }, function () {
          })
        }
      }
    }
</script>
<style lang="scss">
  .add_person_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      text-align: center;
      font-size: 14px;
  
  .add_account {
    min-height: 630px;
    overflow-y: scroll; 
    width: 766px;
    top:5%;
    left: 41%;
    z-index: 101;
    margin-left: -200px;
    position: fixed;

    .el-card__header {
        padding: 10px
    }
    .el-tabs__header {
        margin-bottom: 0;
    }
    .resourseContent {
        text-align: left;
    }
    .upload-demo {
        float: left;
        margin-right: 30px;
    }
    .col-lg-1 {
        width: 25%;
        display: inline-block;
        font-weight: 700;
        color: #777;
        vertical-align: top;
    }
    .col-lg-2 {
        width: 70%;
        display: inline-block;
        textarea {
          height: 120px;
        }
    }

  }
  }
</style> 


// WEBPACK FOOTER //
// src/page/adMgr/popPersonResourse.vue